import React, { useState } from 'react';
import { Container, Row, Col, Button, Card, Modal, Carousel } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt, faChartLine, faUsers, faClipboardList, faPrescriptionBottle, faFileAlt, faIdCard, faShieldAlt, faPlay, faMapMarkerAlt, faClock, faHandshake } from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import logo from '../img/medsolutions.jpg';
import solutionstiLogo from '../img/solutionsti.png';
import dashboardImg from '../img/dashboard web.jpg';
import agendaImg from '../img/agenda web.jpg';
import fichaImg from '../img/ficha paciente web.jpg';
import '../index.css';

export default function LandingPage() {
    const [showDemo, setShowDemo] = useState(false);

    return (
        <div style={{ backgroundColor: '#f8f9fa' }}>
            {/* Hero Section */}
            <section style={{ 
                backgroundColor: '#f4f5ff', 
                color: '#333', 
                padding: '100px 0 60px 0' 
            }}>
                <Container style={{ position: 'relative' }}>
                    <div className="solutions-logo-container">
                        <img 
                            src={solutionstiLogo} 
                            alt="SolutionsTI" 
                            className="solutions-logo"
                        />
                    </div>
                    <Row className="justify-content-center text-center">
                        <Col lg={8}>
                            <div style={{ marginBottom: '30px' }}>
                                <img 
                                    src={logo} 
                                    alt="MedSolutions" 
                                    style={{ 
                                        maxWidth: '400px', 
                                        height: 'auto'
                                    }}
                                />
                            </div>
                            <h2 style={{ fontSize: '1.5rem', marginBottom: '30px', opacity: 0.9 }}>
                                Sistema Completo de Gestão Médica
                            </h2>
                            <p style={{ fontSize: '1.2rem', marginBottom: '40px', opacity: 0.8 }}>
                                Gerencie sua clínica com eficiência. Agenda inteligente, controle de pacientes 
                                e relatórios em tempo real.
                            </p>
                            <div style={{ display: 'flex', gap: '15px', flexWrap: 'wrap', justifyContent: 'center' }}>
                                <Button 
                                    size="lg" 
                                    style={{ 
                                        backgroundColor: '#28a745', 
                                        border: 'none',
                                        padding: '12px 30px',
                                        fontSize: '1.1rem'
                                    }}
                                    onClick={() => window.open('https://www.solutionsti.info', '_blank')}
                                >
                                    Acessar Sistema
                                </Button>
                                <Button 
                                    size="lg" 
                                    style={{ 
                                        backgroundColor: '#667eea', 
                                        border: 'none',
                                        padding: '12px 30px',
                                        fontSize: '1.1rem'
                                    }}
                                    onClick={() => setShowDemo(true)}
                                >
                                    <FontAwesomeIcon icon={faPlay} style={{ marginRight: '8px' }} />
                                    Ver Demonstração
                                </Button>
                                <Button 
                                    variant="outline-light" 
                                    size="lg"
                                    style={{ 
                                        padding: '12px 30px', 
                                        fontSize: '1.1rem',
                                        backgroundColor: '#25d366',
                                        borderColor: '#25d366'
                                    }}
                                    onClick={() => {
                                        window.open('https://wa.me/5532988495161', '_blank');
                                        setTimeout(() => window.location.href = '/obrigado', 1000);
                                    }}
                                >
                                    <FontAwesomeIcon icon={faWhatsapp} style={{ marginRight: '8px' }} />
                                    Contato WhatsApp
                                </Button>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* Features Section */}
            <section style={{ padding: '40px 0' }}>
                <Container>
                    <Row>
                        <Col lg={12} className="text-center mb-5">
                            <h2 style={{ fontSize: '2.5rem', marginBottom: '20px', color: '#333' }}>
                                Principais Funções
                            </h2>
                            <p style={{ fontSize: '1.2rem', color: '#666' }}>
                                O que você precisa para gerenciar sua clínica em um só lugar
                            </p>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg={4} md={6} className="mb-4">
                            <Card style={{ 
                                height: '100%', 
                                border: 'none', 
                                boxShadow: '0 5px 15px rgba(0,0,0,0.1)',
                                transition: 'transform 0.3s'
                            }}>
                                <Card.Body className="text-center p-4">
                                    <FontAwesomeIcon 
                                        icon={faCalendarAlt} 
                                        size="3x" 
                                        style={{ color: '#667eea', marginBottom: '20px' }}
                                    />
                                    <h4 style={{ marginBottom: '15px' }}>Agenda Inteligente</h4>
                                    <p style={{ color: '#666' }}>
                                        Calendário interativo com visualização por médico, 
                                        encaixes automáticos e busca avançada de pacientes.
                                    </p>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col lg={4} md={6} className="mb-4">
                            <Card style={{ 
                                height: '100%', 
                                border: 'none', 
                                boxShadow: '0 5px 15px rgba(0,0,0,0.1)',
                                transition: 'transform 0.3s'
                            }}>
                                <Card.Body className="text-center p-4">
                                    <FontAwesomeIcon 
                                        icon={faUsers} 
                                        size="3x" 
                                        style={{ color: '#28a745', marginBottom: '20px' }}
                                    />
                                    <h4 style={{ marginBottom: '15px' }}>Gestão de Pacientes</h4>
                                    <p style={{ color: '#666' }}>
                                        Cadastro completo, histórico de consultas, 
                                        controle de convênios e busca rápida por nome.
                                    </p>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col lg={4} md={6} className="mb-4">
                            <Card style={{ 
                                height: '100%', 
                                border: 'none', 
                                boxShadow: '0 5px 15px rgba(0,0,0,0.1)',
                                transition: 'transform 0.3s'
                            }}>
                                <Card.Body className="text-center p-4">
                                    <FontAwesomeIcon 
                                        icon={faChartLine} 
                                        size="3x" 
                                        style={{ color: '#ffc107', marginBottom: '20px' }}
                                    />
                                    <h4 style={{ marginBottom: '15px' }}>Dashboards</h4>
                                    <p style={{ color: '#666' }}>
                                        Gráficos em tempo real de status de consultas, 
                                        procedimentos realizados e métricas da clínica.
                                    </p>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col lg={4} md={6} className="mb-4">
                            <Card style={{ 
                                height: '100%', 
                                border: 'none', 
                                boxShadow: '0 5px 15px rgba(0,0,0,0.1)',
                                transition: 'transform 0.3s'
                            }}>
                                <Card.Body className="text-center p-4">
                                    <FontAwesomeIcon 
                                        icon={faClipboardList} 
                                        size="3x" 
                                        style={{ color: '#dc3545', marginBottom: '20px' }}
                                    />
                                    <h4 style={{ marginBottom: '15px' }}>Anamnese/Evolução</h4>
                                    <p style={{ color: '#666' }}>
                                        Linha do tempo completa de todas as consultas 
                                        com histórico detalhado do paciente.
                                    </p>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col lg={4} md={6} className="mb-4">
                            <Card style={{ 
                                height: '100%', 
                                border: 'none', 
                                boxShadow: '0 5px 15px rgba(0,0,0,0.1)',
                                transition: 'transform 0.3s'
                            }}>
                                <Card.Body className="text-center p-4">
                                    <FontAwesomeIcon 
                                        icon={faPrescriptionBottle} 
                                        size="3x" 
                                        style={{ color: '#28a745', marginBottom: '20px' }}
                                    />
                                    <h4 style={{ marginBottom: '15px' }}>Receituário</h4>
                                    <p style={{ color: '#666' }}>
                                        Replique receituários de forma fácil e rápida 
                                        com modelos pré-configurados.
                                    </p>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col lg={4} md={6} className="mb-4">
                            <Card style={{ 
                                height: '100%', 
                                border: 'none', 
                                boxShadow: '0 5px 15px rgba(0,0,0,0.1)',
                                transition: 'transform 0.3s'
                            }}>
                                <Card.Body className="text-center p-4">
                                    <FontAwesomeIcon 
                                        icon={faFileAlt} 
                                        size="3x" 
                                        style={{ color: '#ffc107', marginBottom: '20px' }}
                                    />
                                    <h4 style={{ marginBottom: '15px' }}>Pedidos de Exame</h4>
                                    <p style={{ color: '#666' }}>
                                        Utilize pedidos pré-cadastrados para 
                                        acelerar a emissão de solicitações.
                                    </p>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col lg={4} md={6} className="mb-4">
                            <Card style={{ 
                                height: '100%', 
                                border: 'none', 
                                boxShadow: '0 5px 15px rgba(0,0,0,0.1)',
                                transition: 'transform 0.3s'
                            }}>
                                <Card.Body className="text-center p-4">
                                    <FontAwesomeIcon 
                                        icon={faIdCard} 
                                        size="3x" 
                                        style={{ color: '#6f42c1', marginBottom: '20px' }}
                                    />
                                    <h4 style={{ marginBottom: '15px' }}>Atestados</h4>
                                    <p style={{ color: '#666' }}>
                                        Crie seus atestados personalizados e 
                                        emita de forma rápida e profissional.
                                    </p>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col lg={4} md={6} className="mb-4">
                            <Card style={{ 
                                height: '100%', 
                                border: 'none', 
                                boxShadow: '0 5px 15px rgba(0,0,0,0.1)',
                                transition: 'transform 0.3s'
                            }}>
                                <Card.Body className="text-center p-4">
                                    <FontAwesomeIcon 
                                        icon={faShieldAlt} 
                                        size="3x" 
                                        style={{ color: '#17a2b8', marginBottom: '20px' }}
                                    />
                                    <h4 style={{ marginBottom: '15px' }}>Segurança LGPD/CFM</h4>
                                    <p style={{ color: '#666' }}>
                                        Sistema em conformidade com LGPD e normas do CFM. 
                                        Backup automático e proteção de dados.
                                    </p>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col lg={4} md={6} className="mb-4">
                            <Card style={{ 
                                height: '100%', 
                                border: 'none', 
                                boxShadow: '0 5px 15px rgba(0,0,0,0.1)',
                                transition: 'transform 0.3s'
                            }}>
                                <Card.Body className="text-center p-4">
                                    <FontAwesomeIcon 
                                        icon={faWhatsapp} 
                                        size="3x" 
                                        style={{ color: '#25d366', marginBottom: '20px' }}
                                    />
                                    <h4 style={{ marginBottom: '15px' }}>Confirmação WhatsApp</h4>
                                    <p style={{ color: '#666' }}>
                                        Envie confirmações de consulta e documentos 
                                        diretamente pelo WhatsApp do paciente.
                                    </p>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* Por que escolher MedSolutions */}
            <section style={{ padding: '80px 0', backgroundColor: '#f8f9fa' }}>
                <Container>
                    <Row className="text-center mb-5">
                        <Col>
                            <h2 style={{ color: '#333', marginBottom: '20px' }}>Por que escolher MedSolutions?</h2>
                            <p style={{ fontSize: '1.2rem', color: '#666' }}>Experiência e confiança que fazem a diferença</p>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg={4} className="text-center mb-4">
                            <div style={{ 
                                backgroundColor: 'white', 
                                padding: '40px 30px', 
                                borderRadius: '15px',
                                boxShadow: '0 5px 15px rgba(0,0,0,0.1)',
                                height: '100%'
                            }}>
                                <FontAwesomeIcon icon={faMapMarkerAlt} size="3x" style={{ color: '#667eea', marginBottom: '20px' }} />
                                <h4 style={{ color: '#333', marginBottom: '15px' }}>Empresa Local</h4>
                                <p style={{ color: '#666', fontSize: '1.1rem' }}>Somos de Muriaé - MG, conhecemos as necessidades das clínicas da região</p>
                            </div>
                        </Col>
                        <Col lg={4} className="text-center mb-4">
                            <div style={{ 
                                backgroundColor: 'white', 
                                padding: '40px 30px', 
                                borderRadius: '15px',
                                boxShadow: '0 5px 15px rgba(0,0,0,0.1)',
                                height: '100%'
                            }}>
                                <FontAwesomeIcon icon={faClock} size="3x" style={{ color: '#667eea', marginBottom: '20px' }} />
                                <h4 style={{ color: '#333', marginBottom: '15px' }}>15 Anos de Experiência</h4>
                                <p style={{ color: '#666', fontSize: '1.1rem' }}>Trabalhamos há 15 anos com clínicas médicas, conhecemos cada desafio</p>
                            </div>
                        </Col>
                        <Col lg={4} className="text-center mb-4">
                            <div style={{ 
                                backgroundColor: 'white', 
                                padding: '40px 30px', 
                                borderRadius: '15px',
                                boxShadow: '0 5px 15px rgba(0,0,0,0.1)',
                                height: '100%'
                            }}>
                                <FontAwesomeIcon icon={faHandshake} size="3x" style={{ color: '#667eea', marginBottom: '20px' }} />
                                <h4 style={{ color: '#333', marginBottom: '15px' }}>Suporte Personalizado</h4>
                                <p style={{ color: '#666', fontSize: '1.1rem' }}>Atendimento próximo e suporte técnico especializado quando você precisar</p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* CTA Section */}
            <section style={{ 
                backgroundColor: '#343a40', 
                color: 'white', 
                padding: '60px 0' 
            }}>
                <Container>
                    <Row>
                        <Col lg={8} className="mx-auto text-center">
                            <h2 style={{ fontSize: '2.5rem', marginBottom: '20px' }}>
                                Pronto para Modernizar sua Clínica?
                            </h2>
                            <p style={{ fontSize: '1.2rem', marginBottom: '30px', opacity: 0.8 }}>
                                Junte-se aos profissionais que já utilizam o MedSolutions 
                                para otimizar sua gestão médica.
                            </p>
                            <div style={{ display: 'flex', gap: '15px', justifyContent: 'center', flexWrap: 'wrap' }}>
                                <Button 
                                    size="lg" 
                                    style={{ 
                                        backgroundColor: '#28a745', 
                                        border: 'none',
                                        padding: '15px 40px',
                                        fontSize: '1.2rem'
                                    }}
                                    onClick={() => window.open('https://www.solutionsti.info', '_blank')}
                                >
                                    Começar Agora
                                </Button>
                                <Button 
                                    size="lg" 
                                    style={{ 
                                        backgroundColor: '#25d366', 
                                        border: 'none',
                                        padding: '15px 40px',
                                        fontSize: '1.2rem'
                                    }}
                                    onClick={() => {
                                        window.open('https://wa.me/5532988495161', '_blank');
                                        setTimeout(() => window.location.href = '/obrigado', 1000);
                                    }}
                                >
                                    <FontAwesomeIcon icon={faWhatsapp} style={{ marginRight: '8px' }} />
                                    Fale Conosco
                                </Button>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* Footer */}
            <footer style={{ 
                backgroundColor: '#212529', 
                color: 'white', 
                padding: '40px 0' 
            }}>
                <Container>
                    <Row>
                        <Col lg={6}>
                            <h5>MedSolutions</h5>
                            <p style={{ opacity: 0.7 }}>
                                Sistema completo de gestão médica desenvolvido pela SolutionsTI 
                                para otimizar o atendimento e administração de clínicas.
                            </p>
                        </Col>
                        <Col lg={6} className="text-lg-end">
                            <p style={{ opacity: 0.7, margin: 0 }}>
                                © 2024 SolutionsTI. Todos os direitos reservados.
                            </p>
                        </Col>
                    </Row>
                </Container>
            </footer>

            {/* Modal de Demonstração */}
            <Modal show={showDemo} onHide={() => setShowDemo(false)} size="xl" centered style={{ maxWidth: '95vw' }}>
                <Modal.Header closeButton>
                    <Modal.Title>Demonstração MedSolutions</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Carousel>
                        {/* Slide 1 - Vídeo */}
                        <Carousel.Item>
                            <div style={{ 
                                backgroundColor: '#f8f9fa', 
                                padding: '20px', 
                                borderRadius: '10px',
                                textAlign: 'center',
                                minHeight: '400px'
                            }}>
                                <iframe 
                                    src="https://drive.google.com/file/d/1LxUMWZTnv37GpGdjm9AIt48pIl_h-t6Q/preview" 
                                    width="100%" 
                                    height="600px"
                                    style={{ 
                                        borderRadius: '10px', 
                                        marginBottom: '10px',
                                        border: 'none',
                                        maxWidth: '1200px'
                                    }}
                                    allow="autoplay; fullscreen"
                                    allowFullScreen
                                ></iframe>
                                <Button 
                                    size="sm"
                                    style={{ backgroundColor: '#667eea', border: 'none', marginBottom: '20px' }}
                                    onClick={() => window.open('https://drive.google.com/file/d/1LxUMWZTnv37GpGdjm9AIt48pIl_h-t6Q/view?usp=sharing', '_blank')}
                                >
                                    Visualizar Tela Cheia
                                </Button>
                                <h3>Vídeo Demonstrativo</h3>
                                <p style={{ fontSize: '1.1rem' }}>Veja o MedSolutions em ação</p>
                            </div>
                        </Carousel.Item>
                        
                        {/* Slide 2 - Dashboard */}
                        <Carousel.Item>
                            <div style={{ 
                                backgroundColor: '#f8f9fa', 
                                padding: '20px', 
                                borderRadius: '10px',
                                textAlign: 'center',
                                minHeight: '400px'
                            }}>
                                <img 
                                    src={dashboardImg} 
                                    alt="Dashboard MedSolutions" 
                                    style={{ 
                                        width: '100%', 
                                        height: '500px',
                                        objectFit: 'contain',
                                        borderRadius: '10px',
                                        marginBottom: '20px'
                                    }}
                                />
                                <h3>Dashboard</h3>
                                <p style={{ fontSize: '1.1rem' }}>Gráficos em tempo real de consultas e métricas da clínica</p>
                            </div>
                        </Carousel.Item>
                        
                        {/* Slide 3 - Agenda */}
                        <Carousel.Item>
                            <div style={{ 
                                backgroundColor: '#f8f9fa', 
                                padding: '20px', 
                                borderRadius: '10px',
                                textAlign: 'center',
                                minHeight: '400px'
                            }}>
                                <img 
                                    src={agendaImg} 
                                    alt="Agenda MedSolutions" 
                                    style={{ 
                                        width: '100%', 
                                        height: '500px',
                                        objectFit: 'contain',
                                        borderRadius: '10px',
                                        marginBottom: '20px'
                                    }}
                                />
                                <h3>Agenda</h3>
                                <p style={{ fontSize: '1.1rem' }}>Calendário interativo com visualização por médico e encaixes automáticos</p>
                            </div>
                        </Carousel.Item>
                        
                        {/* Slide 4 - Ficha do Paciente */}
                        <Carousel.Item>
                            <div style={{ 
                                backgroundColor: '#f8f9fa', 
                                padding: '20px', 
                                borderRadius: '10px',
                                textAlign: 'center',
                                minHeight: '400px'
                            }}>
                                <img 
                                    src={fichaImg} 
                                    alt="Ficha do Paciente MedSolutions" 
                                    style={{ 
                                        width: '100%', 
                                        height: '500px',
                                        objectFit: 'contain',
                                        borderRadius: '10px',
                                        marginBottom: '20px'
                                    }}
                                />
                                <h3>Ficha do Paciente</h3>
                                <p style={{ fontSize: '1.1rem' }}>Prontuário completo com histórico de consultas e anamnese detalhada</p>
                            </div>
                        </Carousel.Item>
                    </Carousel>
                    
                    {/* Botão Agendar Demo */}
                    <div className="text-center mt-4">
                        <button 
                            style={{ 
                                backgroundColor: '#25d366', 
                                color: 'white',
                                border: 'none',
                                borderRadius: '5px',
                                padding: '15px 40px',
                                fontSize: '1.2rem',
                                cursor: 'pointer'
                            }}
                            onClick={() => {
                                window.open('https://wa.me/5532988495161?text=Quero%20uma%20Demonstra%C3%A7%C3%A3o%20do%20MedSolutions%20Web', '_blank');
                                setShowDemo(false);
                                setTimeout(() => window.location.href = '/obrigado', 1000);
                            }}
                        >
                            <FontAwesomeIcon icon={faWhatsapp} style={{ marginRight: '8px' }} />
                            Agendar Demonstração Gratuita
                        </button>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    );
}